import axios from "axios";

import { ICourseChapter } from "@/shared/model/course-chapter.model";

const baseApiUrl = "api/course-chapters";

/*
 * FOR ODOPRO / ELEARNING / ODO FORMATION
 */
export default class CourseChapterService {
  public update(entity: ICourseChapter): Promise<ICourseChapter> {
    return new Promise<ICourseChapter>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
